export function setElementStyle(element: any, transform: string, zIndex: number, top: number, isActive: boolean) {
  element.style.transform = transform;
  element.style.zIndex = `${zIndex}`;
  element.style.top = `${top}px`;
  element.setAttribute('active', `${isActive}`);
}
